import * as NotificationsApi from "../../../api/NotificationsApi";
import {fetchNotificationListBegin, fetchNotificationListSuccess} from "../action/NotificationList";

export function fetchNotificationList() {
    return dispatch => {
        dispatch(fetchNotificationListBegin());
        NotificationsApi.notificationList2().then(json => {
            dispatch(fetchNotificationListSuccess({
                notifications: json.data.content,
            }));
        });
    };
}
